
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(1282.021 -5655.75)"}},[_c('circle',{attrs:{"fill":"#FFF","cx":"-1182.02","cy":"5755.75","r":"100"}}),_c('path',{attrs:{"fill":"none","stroke":"#FFBE1B","stroke-width":"18.985","stroke-linecap":"round","d":"M-1230.58 5769.29l34.08 21.46 58.49-73.48"}})])])
          )
        }
      }
    